// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-btn[data-v-79008c68]{max-width:50%!important}.bx--btn-set[data-v-79008c68]{height:100%}", ""]);
// Exports
module.exports = exports;
